import { SetCurrentBlockMobilePageSuccess, SetCurrentSingleAdviceDayAction } from '../../../store/actions';
import { AfterViewInit, Component, HostBinding, Input, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationRoutingService } from '@application-routing';
import { AppState } from '@appStates';
import { LocalizationService, ScreenDetectedService, SeoService } from '@core/services';
import { ListLazyComponents, Pages } from '@enums';
import { Crumb, IAdviceReference, ISingleAdviceDay } from '@interfaces';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';
import { RestUrlService, TypeUrl } from 'src/app/core/services/api.services/settings/rest-url.service';
import { selectCurrentAdviceDay } from 'src/app/store/selectors/start.page.selectors';
import { JsonLDServiceService } from 'src/app/core/services/seo.services/json-ldservice.service';

@Component({
  selector: 'app-advice-day',
  templateUrl: './advice-day.component.html',
  styleUrls: ['./advice-day.component.sass']
})
export class AdviceDayComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() public container: ViewContainerRef;
  public adviceDayTip: Observable<ISingleAdviceDay> = this.store.pipe(select(selectCurrentAdviceDay));
  public images: string;
  public groups: IAdviceReference[];

  private componentDestroyer = new Subject<void>();

  @HostBinding('class.scrollbar') public addScrollbar = false;

  constructor(
    private readonly router: Router,
    private readonly store: Store<AppState>,
    private readonly restUrlService: RestUrlService,
    private readonly seoService: SeoService,
    private readonly localizationService: LocalizationService,
    private readonly screenDetectedService: ScreenDetectedService,
    private readonly JsonLDService: JsonLDServiceService,
    private readonly applicationRoutingService: ApplicationRoutingService
  ) {
    this.seoService.getTegRobots(Pages.tips);
    this.seoService.updateLinkHreflang();
    if (this.screenDetectedService.isDesktop()) {
      this.images = this.restUrlService.getUrl(TypeUrl.img) + '/800-400/';
    } else {
      this.images = this.restUrlService.getUrl(TypeUrl.img) + '/300-150/';
    }

  }

  ngOnInit(): void {
    if (!this.screenDetectedService.isDesktop()) { this.addScrollbar = true; }
  }

  ngAfterViewInit(): void {
    this.adviceDayTip.pipe(
      filter(value => !!value),
      takeUntil(this.componentDestroyer)
    ).subscribe((singleAdviceDay: ISingleAdviceDay) => {
      this.setJsonLdScriptCrumbs(this.generateCrumbsArray(singleAdviceDay));
      this.setJsonLdScriptArticle();
      this.groups = singleAdviceDay.adviceReferences;
    });
  }

  public getHomePageLink(): string {
    return this.localizationService.getLang() === 'ru' ? '/' : '/ua';
  }

  public pushBtnBack(): void {
    this.store.dispatch(SetCurrentBlockMobilePageSuccess({ block: ListLazyComponents.allAdvice }));
    this.applicationRoutingService.navigate(ListLazyComponents.allAdvice, this.router.routerState.snapshot.url);
  }

  private generateCrumbsArray(data: ISingleAdviceDay): Crumb[] {
    const crumbs: Crumb[] = [
      {
        name: this.localizationService.getLang() === 'ru' ? 'Поиск лекарств' : 'Пошук ліків',
        url: this.localizationService.getLang() === 'ru' ? 'https://zdorovi.ua' : 'https://zdorovi.ua/ua'
      },
      { name: data.title, url: null }
    ];
    return crumbs;
  }

  private setJsonLdScriptCrumbs(crumbs: Crumb[]): void {
    this.JsonLDService.add(JsonLDServiceService.Breadcrambs(JsonLDServiceService.mutationCrambs(crumbs)), 'structured-data-crumbs');
  }

  private setJsonLdScriptArticle(): void {
    this.adviceDayTip.pipe(
      filter(value => !!value),
      take(1)
    ).subscribe((advice: ISingleAdviceDay) => {
      const imageSize: string = this.screenDetectedService.isDesktop() ? '800-400' : '300-150';
      this.JsonLDService.add(
        JsonLDServiceService.Artice(advice, imageSize),
        'structured-data-article'
      );
    });
  }

  ngOnDestroy(): void {
    this.componentDestroyer.next(null);
    this.componentDestroyer.complete();
    this.store.dispatch(SetCurrentSingleAdviceDayAction({ advice: null }));
    this.JsonLDService.remove();
  }
}
